module.exports = __webpack_public_path__ + "static/media/fte-yoga-thumbnail.5bbf50ae.png";